module.exports = __webpack_public_path__ + "img/galeries_chagnon.815b8191.webp";